import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { UserEntity } from '../../domain/entities/UserEntity'
import type { UserDto } from '@/backend/market'

export class UserModel extends UserEntity {
  constructor(dataDto: UserDto) {
    super()
    mapEntityProperties<UserEntity>(this, dataDto, {
      map: {
        regions: dataDto.regions?.map((region) => {
          return {
            id: region.id,
            name: region.name,
            location: {
              lat: region.location?.latitude ?? 0,
              lng: region.location?.longitude ?? 0
            }
          }
        })
      }
    })
  }
}
